import "core-js/modules/web.dom-collections.for-each.js";
//

import Cascader from 'element-ui/lib/cascader';
export default {
  name: 'myCascader',
  extends: Cascader,
  props: {
    collapseTags: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  methods: {
    getFlattedNodes2: function getFlattedNodes2(nodes, gatherArr) {
      var _this = this;
      nodes.forEach(function (node) {
        if (node.checked) {
          gatherArr.push(node);
        } else {
          if (node.children && node.children.length) {
            _this.getFlattedNodes2(node.children, gatherArr);
          } else {
            gatherArr.push(node);
          }
        }
      });
      return gatherArr;
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    if (this.multiple) {
      this.panel.getFlattedNodes = function () {
        return _this2.getFlattedNodes2(_this2.panel.store.nodes, []);
      };
      this.panel.syncMultiCheckState();
    }
  }
};